const QA_ORIGIN = 'https://qa.cert.toyota.com';

export const environment = {
  production: false,
  envName: 'qa',
  hostname: 'qa.cert.toyota.com',
  baseApiUrl: 'https://api.qa.cert.toyota.com',
  projectApiPath: '/qa_createproject/',
  dashboardApiPath: '/qa_dashboard/',
  superAdminApiPath: '/qa_superadmin/',
  userApiPath: '/qa_user/',
  redirectUrl: '',
  redirectUri: QA_ORIGIN,
  redirect_uri: QA_ORIGIN,
  proxy: '/{proxy+}',
  postLogoutRedirectUri: QA_ORIGIN,
  baseLoginUrl: `https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/authorize?client_id=13670975-bfc1-4c0f-b776-aaf155481755&response_type=code&redirect_uri=${QA_ORIGIN}&response_mode=query&scope=openid%20profile%20email%20offline_access%20https%3A%2F%2Fgraph.microsoft.com%2FUser.Read&claims=%7B%22access_token%22%3A%7B%22capolids%22%3A%7B%22essential%22%3Atrue%2C%22values%22%3A%5B%222d17fe5e-e439-4910-a5dd-6efa578c163f%22%5D%7D%7D%7D`,
  tokenURL: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/token',
  logoutUrl: 'https://login.microsoftonline.com/common/oauth2/logout',
  grantType: 'authorization_code',
  clientId: '13670975-bfc1-4c0f-b776-aaf155481755',
  redirectURI: QA_ORIGIN,
  scopes: ['user.read', 'email', 'profile'],
  authority: 'https://login.microsoftonline.com/tmnatest.onmicrosoft.com/',
  graphApiUrl: 'https://graph.microsoft.com/v1.0'
};